import React, { useMemo } from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"
import { useSelector } from "react-redux"
import styles from "../../../Calendar.module.css"
import CalendarTimeGrid from "../../CalendarTimeGrid"

const Day = ({ date }) => {
  const { loading, bookings } = useSelector((state) => state.calendar)

  const events = useMemo(() => {
    return bookings?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.formatted_start_time,
      end: booking?.formatted_end_time,
      title: booking?.title,
      date: booking?.formatted_date,
      payment_status: booking?.payment_status
    }))
  }, [bookings])

  return (
    <>
      <CalendarTimeGrid date={date} events={events} type="day" />
      {loading && <Spinner className={styles.spinner} absolute />}
    </>
  )
}

Day.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired
}

export default Day
